import { createReducer, on } from "@ngrx/store";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";
import { obterConteudoCadernoPorId, obterConteudoCadernoPorIdSuccess, obterConteudoCadernoPorIdFailure, obterConteudoCadernoPorIdFinish } from "../../actions/Caderno/obter-conteudo-caderno-por-id.action";

export interface ObterConteudoCadernoPorIdState {
    response: EstruturaRetornoDadosOutputDto<string> | null;
    error: string[] | null;
}

export const initialState: ObterConteudoCadernoPorIdState = {
    response: null,
    error: null,
};

export const ObterConteudoCadernoPorIdReducer = createReducer(
    initialState,
    on(obterConteudoCadernoPorId, state => ({ ...state, error: null })),
    on(obterConteudoCadernoPorIdSuccess, (state, { response }) => ({ ...state, response, error: null })),
    on(obterConteudoCadernoPorIdFailure, (state, { response }) => ({ ...state, response: null, error: response.erros })),
    on(obterConteudoCadernoPorIdFinish, state => ({ ...state, response: null, error: null }))
);